export default "__VITE_ASSET__Dnnoq4Ez__"